import React from 'react';
import { CardDisplay } from 'olaqin-design-system';
import { useDocumentTitle } from 'app/hooks';
import { TITLE_PREFIX } from 'app/constants/appConstants';
import ReportsExportDataTable from './ReportsExportDataTable';

const ReportsExport = () => {
  useDocumentTitle(`${TITLE_PREFIX} Export des données`);

  return (
    <div>
      <p
        style={{
          fontFamily: 'RecifeDisplay',
          fontStyle: 'normal',
          fontWeight: '700',
          fontSize: '38px',
          lineHeight: '40px',
          color: '#19171a',
        }}
      >
        Export des données
      </p>
      <CardDisplay style={{ width: 'auto' }}>
        <ReportsExportDataTable />
      </CardDisplay>
    </div>
  );
};

export default ReportsExport;
